import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import uniqBy from 'lodash/uniqBy';
import Swipe from './Swipe';
import config from 'config';
import { updateProviderTracks } from 'store/actions/providerTracksActions';
import {
  getNewReleases,
  getCuratedTracks,
  getTrendingTracks,
  getFeaturedTracks,
  getRecommendedTracks,
} from 'services/providerService';

export const SwipeCollection = ({
  user,
  providerTracks,
  favoriteGenres,
  updateProviderTracks,
}) => {
  const { type, index } = useParams();
  const [fetching, setFetching] = useState(false);
  const [batchNb, setBatchNb] = useState(1);
  const [trackList, setTrackList] = useState(null);

  const userList = user[type];
  const providerList = providerTracks[type];

  const requestFn = async (offset) => {
    return providerFn[type]
      ? await providerFn[type]({ offset })
      : await getRecommendedTracks({
          type: 'genres',
          references: [type],
          limit: 40,
          offset,
        });
  };

  const providerFn = {
    curated: () => getCuratedTracks(user.favoriteGenres),
    releases: getNewReleases,
    trending: getTrendingTracks,
    featured: getFeaturedTracks,
  };

  useEffect(() => {
    getInitialList();
  }, [user.uid]);

  const getInitialList = async () => {
    try {
      if (userList) {
        // Update local state
        setTrackList(userList);
        setBatchNb(batchNb + 1);
        return userList;
      }
      // If no list in app state found for this type we call the api
      const list = (providerList || []).length
        ? providerList
        : await requestFn();
      // Save tracks in app state
      updateProviderTracks({ type, tracks: list });
      // Update local state
      setTrackList(list);
      setBatchNb(batchNb + 1);
    } catch (error) {
      console.error(error);
    }
  };

  const getNewTracks = async () => {
    try {
      console.log('>>>>>>>> GET MORE TRACKS');
      setFetching(true);
      const offset = batchNb * config.nbOfTracksToFetch;
      const tracks = await requestFn(offset);
      // Concatenate with previous track list and remove potential duplicates
      const newTrackList = uniqBy([].concat(trackList, tracks), 'id');
      // Update the app state with the track list just fetched
      updateProviderTracks({ type, tracks: newTrackList });
      setTrackList(newTrackList);
      setBatchNb(batchNb + 1);
      setFetching(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Swipe
      fetching={fetching}
      collection={trackList}
      onListEnd={providerList && getNewTracks}
      isUserList={!!userList}
      initialSlide={index || 0}
    />
  );
};

const mapStateToProps = (state) => {
  const { user, providerTracks } = state;
  return { user, providerTracks };
};

export default connect(mapStateToProps, { updateProviderTracks })(
  SwipeCollection
);
